import {
  GET_DEPARTMENTS,
  SET_DEPARTMENTS,
  API_ERROR,
  CREATE_DEPARTMENTS,
  CREATED_DEPARTMENTS,
  RESET_DEPARTMENTS,
  GET_DEPARTMENT,
  SET_DEPARTMENT,
  EDIT_DEPARTMENT,
  EDIT_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT,
  DELETE_DEPARTMENT_SUCCESS,
} from "./actionTypes";

export const resetDepartments = () => {
  return {
    type: RESET_DEPARTMENTS,
    payload: {},
  };
};

export const getDepartments = (page, qnt, name, email, slug) => {
  return {
    type: GET_DEPARTMENTS,
    payload: { page, qnt, name, email, slug },
  };
};

export const loadDepartments = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_DEPARTMENTS,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createDepartment = (newDepartmentValues) => {
  return {
    type: CREATE_DEPARTMENTS,
    payload: { newDepartmentValues },
  };
};

export const createdDepartment = (newDepartmentValues, message) => {
  return {
    type: CREATED_DEPARTMENTS,
    payload: { newDepartmentValues, message },
  };
};

export const getDepartment = (idDepartment) => {
  return {
    type: GET_DEPARTMENT,
    payload: { idDepartment },
  };
};

export const setDepartment = (data) => {
  return {
    type: SET_DEPARTMENT,
    payload: { data },
  };
};

export const editDepartment = (newDepartmentValues, idDepartment) => {
  return {
    type: EDIT_DEPARTMENT,
    payload: { newDepartmentValues, idDepartment },
  };
};

export const editDepartmentSuccess = (newDepartmentValues, message) => {
  return {
    type: EDIT_DEPARTMENT_SUCCESS,
    payload: { newDepartmentValues, message },
  };
};

export const deleteDepartment = (idDepartment) => {
  return {
    type: DELETE_DEPARTMENT,
    payload: { idDepartment },
  };
};

export const deleteDepartmentSuccess = (idDepartment, message) => {
  return {
    type: DELETE_DEPARTMENT_SUCCESS,
    payload: { idDepartment, message },
  };
};
